'use strict';
define(
	'gameLoader',['settings', 'domControl', 'domBids', 'errorHandler', 'bidsService', 'codes', 'streamControl',
		'oldDomControl', 'jquery', 'translations', 'pokerMap', 'Fraction'
	],
	function (settings, newDom, newDomBids, errorHandler, bidsService, codes, streamControl, oldDom,
		$, T, pokerMap, Fraction) {
		var loaded = {
				bets: false,
				game: false,
				history: false
			},
			templates = {
				single: 'templates/single-game.html',
				split: 'templates/split-screen.html'
			},
			domControl,
			domBids,
			internetErrorsObj = {},
			evtSource;
		let previousInstanceUUID = '',
			 gameName,
			 pokerLastEventID,
			 pokerHistory = [];

		function waitForLoad(fnc) {
			setTimeout(fnc, 1000);
		}

		function loadTemplate() {
			var selectedTpl = '';

			domControl = newDom;
			domBids = newDomBids;

			switch (settings.games.length) {
				case 1:
					selectedTpl = 'single';
					if (settings.local.template === 'old') {
						domControl = oldDom;
						domBids = oldDom;
					}
					break;
				case 2:
					selectedTpl = 'split';
					break;
				default:
					break;
			}

			const foundPoker = settings.games.find(function (_, gamePlace) {
				return settings.getGameName(gamePlace) === 'poker';
			});

			if (!foundPoker) {
				streamControl.setScreenActions(domControl.actionBeforeStream, domControl.actionAfterStream);
			}

			$.ajax(templates[selectedTpl], { dataType: 'html', cache: false })
				.done(function (content) {
					domControl.loadTemplate(content);
					loadGameData();
				});
		}

		function loadGameData() {
			settings.games.forEach(function (game, gamePlace) {
				var betKeys = Object.keys(game.config[game.module].betTypes),
					odds = [];

				gameName = settings.getGameName(gamePlace);

				betKeys.forEach(function (bet) {
					if (bet.split('.')[0] === gameName) {
						if (gameName === 'poker') {
							const formattedOdds = getPokerOdds(pokerMap.probMap[bet].prob, pokerMap.probMap[bet].prob, game.config[game.module].betTypes[bet]);

							odds.push({
								// disabled bets until stream loads
								isEnabled: false,
								name: bet,
								formattedOdd: formattedOdds,
								odd: formattedOdds,
								code: codes[bet],
								bid: 0
							});
						} else {
							odds.push({
								name: bet,
								odd: game.config[game.module].betTypes[bet],
								code: codes[bet],
								bid: 0
							});
						}
					}
				});

				odds.sort((oddX, oddY) => oddX.code - oddY.code);
				domControl.showBets(odds, gamePlace);
				startNewGame(gamePlace);
				if (gameName === 'poker') {
					domControl.setFullScreenPoker();
				}
				loaded.bets = true;
			});
			checkIfLoaded();
			domBids.startSlider();
		}
		// Check if everything is loaded. If it is - remove loading screen
		function checkIfLoaded() {
			if (loaded.bets && loaded.history && loaded.game) {
				domControl.showScreen();
				errorHandler.logError('INFO', 'first run of game');
				return;
			}
			waitForLoad(checkIfLoaded);
		}

		function pokerStream(gameConfig, gameNo) {
			if (evtSource) {
				evtSource.close();
			}
			evtSource = new EventSource(`${gameConfig.baseUrl}/poker/instance/stream?lastEventID=${pokerLastEventID}`);

			evtSource.onmessage = (event) => {
				const data = JSON.parse(event.data)[0],
				 activeRound = data.data
					&& data.data.rounds
					&& data.data.rounds.find(x => x.isActive);

				if (data.result && Date.parse(data.startTime) > Date.parse(pokerHistory[0].startTime)) {
					pokerLastEventID = data.instanceLogID;
					pokerHistory.unshift(data);
					pokerHistory.length = 3;
					domControl.showHistory(pokerHistory, gameNo);

					sendInternetErrors();
				}

				if (!activeRound) {
					return;
				}

				if (activeRound.odds) {
					domControl.showBets(getPokerRoundOdds(activeRound, gameConfig), 0);
					domControl.setSlider(new Date(activeRound.time).getTime() - new Date().getTime(), gameNo);
				}

				const roundTime = new Date(activeRound.time).getTime() - Date.now();

				// If instance uuid changed, it should subscribe to the new instance event stream
				// and update bids to calculate total stake.
				if (previousInstanceUUID !== data.uuid && data.resulted === false) {
					bidsService.listenForBids(data.uuid, gameNo, showBids);
					previousInstanceUUID = data.uuid;
				}

				domControl.setTimeLeft(Math.floor(roundTime / 1000), gameNo, data);
			};
			evtSource.onerror = () => {
				setTimeout(function () {
					startNewGame(gameNo);
				}, 5000);
			};
		}

		function startNewGame(gameNo) {
			var game = settings.games[gameNo];

			domBids.resetBids(gameNo);

			if (game.module !== 'betgames-poker') {
				loadHistory(game, gameNo);
				loadNextGame(game, gameNo);
			} else {
				const gameConfig = game.config[game.module],
				 promise = $.ajax({
						url: `${gameConfig.baseUrl}/poker/instance/state`,
						method: 'GET',
						dataType: 'json'
					});

				promise
					.then(function ({ lastEventID, instances }) {
						pokerLastEventID = lastEventID;
						const currentInstance = instances.filter(item => !item.cancelled && Object.keys(item.data).length > 0).sort((a, b) => a.code - b.code)[0],
						 currentInstanceData = currentInstance && currentInstance.data;

						if (!currentInstanceData || !currentInstanceData.rounds) {
							return;
						}

						const activeRound = currentInstanceData.rounds.find(round => round.isActive);

						if (activeRound && activeRound.odds) {
							const odds = getPokerRoundOdds(activeRound, gameConfig);

							domControl.showBets(odds, 0);
						}
						loadPokerHistory(settings.games[gameNo], gameNo);
						pokerStream(gameConfig, gameNo);

						loaded.game = true;
						sendInternetErrors();
						setupGame(currentInstance, gameNo);
					})
					.fail(function (err) {
						errorHandler.showError(T.translate('translate_err2'), 2000);
						setTimeout(function () {
							startNewGame(gameNo);
						}, 5000);

						if (err.status === 0) {
							internetErrorsObj.getNextGame = internetErrorsObj.getNextGame || {
								responseText: err.responseText,
								status: err.status,
								statusText: err.statusText,
								failCount: 0
							};
							internetErrorsObj.getNextGame.failCount++;
							return;
						}

						errorHandler.logError('ERROR', 'error while getting next game', err, {
							url: settings.games[gameNo].config[settings.games[gameNo].module].baseUrl + '/' +
								settings.games[gameNo].config[settings.games[gameNo].module].moduleGameType + '/next'
						});
					});
			}
		}

		function sendInternetErrors() {
			if (Object.keys(internetErrorsObj).length > 0) {
				errorHandler.logError('ERROR', 'internet problems error', null, {
					errors: internetErrorsObj
				});
				internetErrorsObj = {};
			}
		}

		function loadHistory(game, gamePlace) {
			var limit = loaded.history ? '' : '?limit=100',
				gameConfig = game.config[game.module];

			$.ajax({
				url: gameConfig.baseUrl + '/' + gameConfig.moduleGameType + '/history' + limit,
				method: 'GET',
				timeout: 10000,
				dataType: 'json'
			})
				.then(function (history) {
					const formattedHistory = history.map((historyGame) => {
						return Object.assign(historyGame, { game: settings.convertGameType(historyGame.game) })
					});

					sendInternetErrors();
					loaded.history = true;
					domControl.showHistory(formattedHistory, gamePlace);

					if ((!formattedHistory[0].result || Object.keys(formattedHistory[0].result).length === 0) && !formattedHistory[0].cancelled) {
						streamControl.streamEnd(gamePlace, loadHistory, formattedHistory[0].uuid);
					}

					if (typeof settings.local.promoVideoURL === 'string') {
						streamControl.showPromotion(settings.local.promoVideoURL);
					}
				})
				.fail(function (err) {
					errorHandler.showError(T.translate('translate_err3'), 2000);
					setTimeout(function () {
						loadHistory(game, gamePlace);
					}, 5000);

					if (err.status === 0) {
						internetErrorsObj.getHistory = internetErrorsObj.getHistory || {
							responseText: err.responseText,
							status: err.status,
							statusText: err.statusText,
							failCount: 0
						};
						internetErrorsObj.getHistory.failCount++;
						return;
					}

					gameConfig = settings.games[gamePlace].config[settings.games[gamePlace].module];
					errorHandler.logError('ERROR', 'error while getting history', err, {
						url: gameConfig.baseUrl + '/' + gameConfig.moduleGameType + '/history'
					});
				});
		}

		function loadPokerHistory(game, gamePlace) {
			const	gameConfig = game.config[game.module];

			$.ajax({
				url: gameConfig.baseUrl + '/' + gameConfig.moduleGameType + '/history?limit=4',
				method: 'GET',
				timeout: 10000,
				dataType: 'json'
			})
				.then((history) => {
					sendInternetErrors();
					loaded.history = true;
					if (pokerHistory.length > 0) {
						pokerHistory.unshift(history);
					} else {
						pokerHistory = history;
					}
					pokerHistory = pokerHistory.filter(item => item.resulted).sort((a, b) => b.code - a.code);
					pokerHistory.length = pokerHistory.length >= 3 ? 3 : pokerHistory.length;
					domControl.showHistory(pokerHistory, gamePlace);

					if (typeof settings.local.promoVideoURL === 'string') {
						streamControl.showPromotion(settings.local.promoVideoURL);
					}
				})
				.fail(function (err) {
					errorHandler.showError(T.translate('translate_err3'), 2000);
					setTimeout(function () {
						loadPokerHistory(game, gamePlace);
					}, 5000);

					if (err.status === 0) {
						internetErrorsObj.getHistory = internetErrorsObj.getHistory || {
							responseText: err.responseText,
							status: err.status,
							statusText: err.statusText,
							failCount: 0
						};
						internetErrorsObj.getHistory.failCount++;
						return;
					}

					errorHandler.logError('ERROR', 'error while getting history', err, {
						url: gameConfig.baseUrl + '/' + gameConfig.moduleGameType + '/history'
					});
				});
		}

		function loadNextGame(game, gamePlace) {
			const promise = $.ajax({
				url: game.config[game.module].baseUrl + '/' + game.config[game.module].moduleGameType + '/next',
				timeout: 10000,
				method: 'GET',
				dataType: 'json'
			});

			promise
				.then(function (response) {
					const nextGameData = response;

					loaded.game = true;
					sendInternetErrors();
					setupGame(nextGameData, gamePlace);
				})
				.fail(function (err) {
					errorHandler.showError(T.translate('translate_err2'), 2000);
					setTimeout(function () {
						loadNextGame(game, gamePlace);
					}, 5000);

					if (err.status === 0) {
						internetErrorsObj.getNextGame = internetErrorsObj.getNextGame || {
							responseText: err.responseText,
							status: err.status,
							statusText: err.statusText,
							failCount: 0
						};
						internetErrorsObj.getNextGame.failCount++;
						return;
					}

					errorHandler.logError('ERROR', 'error while getting next game', err, {
						url: settings.games[gamePlace].config[settings.games[gamePlace].module].baseUrl + '/' +
							settings.games[gamePlace].config[settings.games[gamePlace].module].moduleGameType + '/next'
					});
				});
		}

		function getPokerOdds(newProbability, baseProbability, baseOdds, marginFromSettings) {
			if (newProbability === 0 || baseProbability === 0 || baseOdds === 0) {
				return '0';
			}

			const margin = !isNaN(marginFromSettings)
					? marginFromSettings
					: new Fraction(1).sub(new Fraction(baseProbability).mul(new Fraction(baseOdds))),
			 fairOdds = new Fraction(1).div(new Fraction(newProbability)),
			 ratOdds = fairOdds.sub(fairOdds.mul(margin));

			return prettifyOdds(ratOdds.valueOf()).toFixed(2);
		}

		function prettifyOdds(odds) {
			switch (true) {
				case (odds < 5):
					return Math.round(odds * 100, 2) / 100;
				case (odds < 10):
					return Math.round(Math.floor(odds * 20) / 20 * 100) / 100;
				case (odds < 20):
					return Math.round(Math.floor(odds * 2) / 2 * 10) / 10;
				case (odds < 40):
					return Math.floor(odds);
				default:
					return Math.round(Math.floor(odds / 5) * 5 * 100) / 100;
			}
		}

		function getPokerRoundOdds(activeRound, gameConfig) {
			const dynamicOddsLimit = gameConfig.dynamicOddsLimit,
			 isDynamicOddsEnabled = !isNaN(dynamicOddsLimit)
				&& dynamicOddsLimit !== 0
				&& dynamicOddsLimit > 1,

			 odds = Object.entries(activeRound.odds).map(([oddKey, oddObject]) => {
					const betKey = pokerMap.keyMap[oddKey],
				 marginFromSettings = gameConfig.bets[betKey]
					&& gameConfig.bets[betKey].margins
					&& gameConfig.bets[betKey].margins[Number(activeRound.ID) - 1],
				 betOdds = getPokerOdds(oddObject.probability, pokerMap.probMap[betKey].prob, gameConfig.betTypes[betKey], marginFromSettings),
				 isEnabled = Number(betOdds) > 1 && oddObject.isEnabled,
				 actualOdds = isDynamicOddsEnabled && Number(betOdds) > dynamicOddsLimit
							? dynamicOddsLimit
							: betOdds;

					return {
						isEnabled,
						formattedOdd: actualOdds,
						code: codes[betKey] || '-',
						name: betKey
					};
				});

			odds.sort((oddX, oddY) => oddX.code - oddY.code);

			return odds;
		}

		function loadGameStream(gameSettings, gameData, gameNo, videoStartTime) {
			var gameConfig = gameSettings.config[gameSettings.module],
				currentTime = Date.now(),
				playerConfig = settings.player[gameConfig.gameType],
				uri = playerConfig.lowLatency
					? 'feed-player-ll-data'
					: 'feed-player-hls-data',
				url = `${gameConfig.baseUrl}/${gameConfig.moduleGameType}/${uri}`;

			streamControl.initStream(playerConfig.prerecorded, playerConfig.gameID, url, gameData)
				.then(function () {
					let requestDuration = Date.now() - currentTime;

					if (gameData.game === 'rng-wheel') {
						if (evtSource) {
							evtSource.close();
						}

						evtSource = new EventSource(`${gameConfig.baseUrl}/rng-wheel/instance/stream`);

						evtSource.onmessage = (event) => {
							const data = JSON.parse(event.data)[0];

							if (data.result !== null && !data.resulted) {
								requestDuration = Date.now() - currentTime;

								sendInternetErrors();
								setTimeout(function () {
									streamControl.showStream(data.videoURL, gameData,
										startNewGame, gameNo);
								}, videoStartTime - requestDuration);
							}
						};
						return;
					}
					sendInternetErrors();
					setTimeout(function () {
						streamControl.showStream(url, gameData, gameData.game === 'poker'
							? () => {}
							: startNewGame, gameNo);
					}, videoStartTime - requestDuration);
				}).catch((e) => {
					console.warn(e);
				});
		}

		function setupGame(gameData, gameNo) {
			var currentGame = gameData,
				currentTime = Date.now(),
				videoStartTime = currentGame.untilStartTime + 3 * 1000,
				streamLoadTime = gameName !== 'poker' ? videoStartTime - 10 * 1000 : 0,
				streamStartOffset = gameName !== 'poker' ? videoStartTime - streamLoadTime : 0;

			currentGame.game = settings.convertGameType(currentGame.game);

			previousInstanceUUID = currentGame.uuid;

			if (gameName !== 'poker' && Object.prototype.hasOwnProperty.call(domControl, 'nextGame')) {
				domControl.nextGame(gameData);
			}

			if (gameName === 'poker' && currentGame.data && currentGame.data.rounds) {
				const activeRound = currentGame.data.rounds.find(round => round.isActive);

				videoStartTime = activeRound
					? new Date(activeRound.time).getTime() - currentTime
					: 0;
			}

			if (gameName === 'poker') {
				domControl.showGameCode(gameNo, currentGame.code);
			}

			currentGame.resolveTime = new Date(currentGame.finishTime) -
				new Date(currentGame.startTime) + currentGame.untilStartTime;
			currentGame.gameStart = currentTime + currentGame.untilStartTime;
			currentGame.gameEnd = currentTime + currentGame.resolveTime;

			domControl.setSlider(videoStartTime, gameNo); // Yellow slider on top
			bidsService.listenForBids(currentGame.uuid, gameNo, showBids);

			let videoStartTimeSeconds = Math.floor(videoStartTime / 1000);

			// First & second game total betting close time equals 420
			// Additional 20 added as a safe guard.
			if (gameName === 'poker' && videoStartTimeSeconds > 440) {
				// We usually get incorrect untilBetCloseTime, when cards are dealt
				// By setting videoStarTimeSeconds value as 0
				// We ensure that we will display to the user "Dealing Cards" section
				videoStartTimeSeconds = 0;
			}

			let timeLeft = videoStartTime;

			const eventStartsLaterThanBetsClose = currentGame.untilStartTime > currentGame.untilBetCloseTime;
			if (eventStartsLaterThanBetsClose) {
				timeLeft = currentGame.untilBetCloseTime + 3 * 1000;
			}

			domControl.setTimeLeft(Math.floor(timeLeft / 1000), gameNo, currentGame);

			setTimeout(function () {
				loadGameStream(settings.games[gameNo], currentGame, gameNo, streamStartOffset);
			}, streamLoadTime);
		}

		function showBids(data, gameNo) {
			// When a new event is presented, it has no bids, which means it will not
			// update total stake or change stakes in the list for bet types.
			if (Object.keys(data).length) {
				domBids.updateBids(data, gameNo);
				return;
			}

			// Solution is to just completely reset the bids,
			// this will force total stake to be recalculated
			domBids.resetBids(gameNo);
		}

		return {
			loadGames: loadTemplate
		};
	}
);

